// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { PageNav_1 } from "@ifeng-fe/lowcode_basic/src/components/nav/PageNav_1/index.tsx";

import { LayoutComponent } from "@ifeng-fe/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { Row } from "@ifeng-fe/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng-fe/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng-fe/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng-fe/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_7 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_7/index.tsx";

import { NewsList_5 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_5/index.tsx";

import { ImageLink } from "@ifeng-fe/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { NewsList_11 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_11/index.tsx";

import { NewsList_6 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_6/index.tsx";

import { NewsList_3 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_3/index.tsx";

import { VideoList_2 } from "@ifeng-fe/lowcode_basic/src/index.tsx";

import { Swiper_finance } from "@ifeng-fe/lowcode_business/src/components/swiper/Swiper_finance/index.tsx";

import { Image_Tabs } from "@ifeng-fe/lowcode_business/src/components/images/Image_Tabs/index.tsx";

import { NewsList_2 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_2/index.tsx";

import { Support } from "@ifeng-fe/lowcode_basic/src/components/popular/Support/index.tsx";

import { Comment } from "@ifeng-fe/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng-fe/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div>
        <Container
          width={1000}
          isCenter={true}
          $isHide={false}
          nodeId="node_ocl75lh7p82"
        >
          <PageNav_1
            navChip={{
              $data: true,
              id: "260700",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260274" },
              uuid: "a923c58a",
            }}
            nodeId="node_ocl75lh7p81"
          />
        </Container>
        <Container
          isCenter={true}
          $isHide={false}
          style={{
            backgroundImage:
              "url(https://x0.ifengimg.com/ucms/2023_36/6C61FFCC067F63BEFDA6B010230F6608EC280C85_size239_w1920_h815.jpg)",
            paddingTop: "300px",
            backgroundPositionX: "center",
            backgroundRepeat: "no-repeat",
            minWidth: "1000px",
          }}
          nodeId="node_ocl7442mzl1"
          hoverStyle=""
        >
          <Container
            width={1000}
            isCenter={true}
            $isHide={false}
            nodeId="node_ocl7442mzl3"
          >
            <Container isCenter={true} $isHide={false}>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcb">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col
                    width={{ type: "flex", size: "1" }}
                    style={{ marginRight: "30px" }}
                  >
                    <Title
                      height={54}
                      image=""
                      text=""
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={true}
                      style={{ marginBottom: "20px" }}
                      textIcon="https://y2.ifengimg.com/a/2014_15/7b090fcd6711a14.jpg"
                    />
                    <NewsList_1
                      newsChip={{
                        $data: true,
                        id: "287948",
                        type: "recommend",
                        title: "新闻内容",
                        default: { type: "recommend", id: "285838" },
                        uuid: "6c9986e9",
                        force: 1661225459857,
                      }}
                      hoverColor="#ba2636"
                      titleStyle={{
                        color: "#2b2b2b",
                        fontSize: "24px",
                        lineHeight: "32px",
                        marginBottom: "9px",
                      }}
                      subTitleGroupSize={2}
                      subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                      nodeId="node_ocl744mcf617"
                      itemStyle={{
                        paddingBottom: "24px",
                        marginTop: "24px",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#ebebeb",
                      }}
                      isHasThumbnail={false}
                      thumbnailWidth={140}
                      thumbnailHeight={100}
                      thumbnailStyle={{ marginRight: "20px" }}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ size: 323, type: "px" }}>
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2023_36/741C547593DCA1482153DA41B1E7874EC4ABDB82_size2_w325_h50.jpg"
                      text="焦点图"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{ paddingLeft: "10px" }}
                      nodeId="node_ocl744mcf618"
                      hoverStyle=""
                    />
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287949",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "e0195eef",
                      }}
                      height={260}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={true}
                      autoSpeed={3000}
                      skin={1}
                      nodeId="node_ocl744mcf619"
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      hoverStyle=""
                    />
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2023_36/741C547593DCA1482153DA41B1E7874EC4ABDB82_size2_w325_h50.jpg"
                      text="视频"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                        paddingLeft: "0px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{
                        marginTop: "30px",
                        marginBottom: "0px",
                        paddingLeft: "10px",
                      }}
                      nodeId="node_ocl744mcf61a"
                      hoverStyle=""
                    />
                    <VideoList_1
                      videoChip={{
                        $data: true,
                        id: "287950",
                        type: "recommend",
                        title: "视频列表",
                        format: {
                          filter: ["title", "posterUrl", "videoPlayUrl"],
                        },
                        default: { type: "recommend", id: "285924" },
                        uuid: "bdd6aeb8",
                      }}
                      width={323}
                      height={240}
                      autoPlay={false}
                      controls={true}
                      hoverColor="#ba2636"
                      skin={0}
                      continuePlay={false}
                      listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                      listIconWidth={14}
                      listIconHeight={9}
                      listStyle={{
                        paddingLeft: "19px",
                        paddingRight: "10px",
                        height: "48px",
                        fontSize: "14px",
                        color: "#2b2b2b",
                        lineHeight: "48px",
                      }}
                      nodeId="node_ocl744mcf61b"
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln15w3vl1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月27日开幕式"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "287978",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "47859b0f",
                  }}
                  mainArticleTitleStyle={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "32px",
                    lineHeight: "40px",
                    marginBottom: "30px",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln13mmt62">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月27日主旨演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "287979",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "5309539f",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln1g6sxe1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月27日圆桌论坛（香港场）"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "287986",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "534e1b4f",
                  }}
                />
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  nodeId="node_ocl95cvq7412"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  />
                </Row>
              </LayoutComponent>
              <LayoutComponent
                isCenter={true}
                nodeId="node_oclmk6g5io1"
                hoverStyle=""
                style={{ marginTop: "30px" }}
              >
                <ImageLink
                  image="https://x0.ifengimg.com/ucms/2023_37/A895395E82FDD976FB6D1C20B9C8097CD9AF694C_size27_w1000_h90.jpg"
                  url=""
                  isBlock={true}
                  width={300}
                  height={90}
                  objectFit=""
                  nodeId="node_oclmk6g5io2"
                  hoverStyle=""
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln1h8are2">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月27日圆桌论坛（深圳场）"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "287987",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "ee794f98",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcd">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="2023凤凰之星港股最佳上市公司评选"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p85"
                  hoverStyle=""
                />
                <NewsList_11
                  chips={{
                    newsChip: {
                      title: "新闻内容",
                      id: "",
                      type: "recommend",
                      defaultId: "285873",
                      uuid: "04b973b4",
                    },
                  }}
                  colNum={2}
                  colPadding={35}
                  showColBorder={true}
                  itemStyle={{ paddingTop: "15px", paddingBottom: "15px" }}
                  itemAlignCenter={false}
                  itemHoverColor="#ba2636"
                  showThumbnail={true}
                  thumbnailWidth={122}
                  thumbnailHeight={122}
                  showThumbnailHoverScale={true}
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                  showSummary={true}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  newsChip={{
                    $data: true,
                    id: "287952",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "position",
                        "newsTime",
                      ],
                    },
                    default: { type: "recommend", id: "285873" },
                    uuid: "6d271df2",
                  }}
                  showTime={false}
                  nodeId="node_ocl75lh7p87"
                  hoverStyle=""
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln2p9iq91">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月28日主旨演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
              </LayoutComponent>
              <NewsList_6
                newsChip={{
                  $data: true,
                  id: "287991",
                  type: "recommend",
                  title: "新闻内容",
                  default: { type: "recommend", id: "285916" },
                  uuid: "746931bc",
                }}
                nodeId="node_ocln2p9iq95"
              />
              <LayoutComponent isCenter={true} nodeId="node_ocln2t75wp1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="9月28日圆桌论坛"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "287992",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "207fd757",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent
                isCenter={true}
                nodeId="node_ocl7o7awmcc"
                hoverStyle=""
              >
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="凤凰云夜话-洪灏对话米歇尔·渥克"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    display: "block",
                    width: "180px",
                    height: "50px",
                  }}
                  isHasAddonAfterIcon={false}
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <NewsList_3
                  newsChip={{
                    $data: true,
                    id: "287951",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285872" },
                    uuid: "beba7e2b",
                  }}
                  isMore={false}
                  nodeId="node_ocl75lh7p84"
                  hoverStyle=""
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocln42o2ad1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="凰家会客厅"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p88"
                  hoverStyle=""
                />
              </LayoutComponent>
              <VideoList_2
                videoChip={{
                  $data: true,
                  id: "287993",
                  type: "recommend",
                  title: "视频列表",
                  format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                  default: { type: "recommend", id: "287366" },
                  uuid: "5fd10a59",
                }}
                width={1000}
                height={563}
                controls={true}
                videoArrowShow={true}
                videoArrowBtnPrev="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                videoArrowNext="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                videoArrowWidth={22}
                videoArrowHeight={40}
                videoArrowY={290}
                videoArrowX={15}
                slidesPerView={4}
                itemThumbWidth={220}
                itemThumbHeight={124}
                showItemTitle={true}
                listArrowShow={true}
                listArrowPrev="https://x2.ifengimg.com/fe/shank/channel/pre_2x.a60b84fc.png"
                listArrowNext="https://x2.ifengimg.com/fe/shank/channel/next_2x.9f8e76e2.png"
                listArrowWidth={30}
                listArrowHeight={60}
                listArrowY={62}
                listArrowX={0}
                itemStyle={{
                  fontSize: "14px",
                  color: "#2b2b2b",
                  lineHeight: "20px",
                }}
                itemCurrentStyle={{ color: "#d04848" }}
              />
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmce">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="陆家嘴日报"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p88"
                  hoverStyle=""
                />
                <Swiper_finance
                  swiperChip={{
                    $data: true,
                    id: "260701",
                    type: "struct",
                    title: "轮播图内容",
                    default: { type: "struct", id: "260257" },
                    uuid: "e6ded56f",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcg">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="精彩图集"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8c"
                  hoverStyle=""
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "287954",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "ffb12299",
                  }}
                  height={620}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={22}
                  navHeight={40}
                  navY={290}
                  navX={15}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={2}
                  nodeId="node_ocl75lh7p8d"
                  isHasTitle={true}
                  titleHeight={40}
                  titleStyle={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    fontSize: "14px",
                    paddingLeft: "8px",
                  }}
                  isHasPagination={true}
                  paginationPosition="titleRight"
                  paginationNormalStyle={{
                    backgroundColor: "#b8defb",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    width: "16px",
                    height: "16px",
                    marginLeft: "4px",
                    marginRight: "7px",
                  }}
                  paginationActiveStyle={{ backgroundColor: "#2879bc" }}
                  paginationTotalStyle={{}}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmch">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="议程"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8e"
                  hoverStyle=""
                />
                <Image_Tabs
                  imagesChip={{
                    $data: true,
                    id: "260702",
                    type: "struct",
                    title: "图片信息",
                    default: { type: "struct", id: "260307" },
                    uuid: "ce1af4a3",
                  }}
                  contentHeight={800}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcf">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="湾区风云录"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8a"
                  hoverStyle=""
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  isHasAddonAfterIcon={true}
                  addonAfterIcon="https://x0.ifengimg.com/ucms/2023_38/1E03F77F9F603A279D052A5D4281E05C7868A924_size2_w150_h50.png"
                  addonAfterIconHeightFull={true}
                  textIconHeightFull={true}
                />
                <VideoList_2
                  videoChip={{
                    $data: true,
                    id: "287957",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "287366" },
                    uuid: "80b06050",
                  }}
                  width={1000}
                  height={563}
                  controls={true}
                  videoArrowShow={true}
                  videoArrowBtnPrev="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  videoArrowNext="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  videoArrowWidth={22}
                  videoArrowHeight={40}
                  videoArrowY={290}
                  videoArrowX={15}
                  slidesPerView={4}
                  itemThumbWidth={220}
                  itemThumbHeight={124}
                  showItemTitle={true}
                  listArrowShow={true}
                  listArrowPrev="https://x2.ifengimg.com/fe/shank/channel/pre_2x.a60b84fc.png"
                  listArrowNext="https://x2.ifengimg.com/fe/shank/channel/next_2x.9f8e76e2.png"
                  listArrowWidth={30}
                  listArrowHeight={60}
                  listArrowY={62}
                  listArrowX={0}
                  itemStyle={{
                    fontSize: "14px",
                    color: "#2b2b2b",
                    lineHeight: "20px",
                  }}
                  itemCurrentStyle={{ color: "#d04848" }}
                  nodeId="node_oclmbfcnrz1"
                  hoverStyle=""
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmci">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="相关报道"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8f"
                  hoverStyle=""
                />
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col
                    width={{ type: "flex", size: "1" }}
                    nodeId="node_ocl75lh7p81o"
                    hoverStyle=""
                  >
                    <Title
                      height={30}
                      image=""
                      text="嘉宾观点"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                      nodeId="node_ocl75lh7p81r"
                      hoverStyle=""
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287956",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "71c65fbe",
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginRight: "6px",
                        width: "9px",
                        height: "9px",
                        backgroundColor: "#cececd",
                        borderTopLeftRadius: "100px",
                        borderTopRightRadius: "100px",
                        borderBottomLeftRadius: "100px",
                        borderBottomRightRadius: "100px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ fontSize: "14px", lineHeight: "24px" }}
                      isHasTime={true}
                      nodeId="node_ocl75lh7p81s"
                      hoverStyle=""
                    />
                    <Title
                      height={30}
                      image=""
                      text="凤凰之星港股评选"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                      nodeId="node_ocl75lh7p81r"
                      hoverStyle=""
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287988",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "4501a701",
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginRight: "6px",
                        width: "9px",
                        height: "9px",
                        backgroundColor: "#cececd",
                        borderTopLeftRadius: "100px",
                        borderTopRightRadius: "100px",
                        borderBottomLeftRadius: "100px",
                        borderBottomRightRadius: "100px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ fontSize: "14px", lineHeight: "24px" }}
                      isHasTime={true}
                      nodeId="node_ocl75lh7p81s"
                      hoverStyle=""
                    />
                    <Title
                      height={30}
                      image=""
                      text="相关报道"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                      nodeId="node_ocl75lh7p81p"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287955",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "3a3a9440",
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasTime={true}
                      titleHoverColor="#ba2636"
                      titleStyle={{ fontSize: "14px", lineHeight: "24px" }}
                      isHasDot={true}
                      dotStyle={{
                        marginRight: "6px",
                        width: "9px",
                        height: "9px",
                        backgroundColor: "#cececd",
                        borderTopLeftRadius: "100px",
                        borderTopRightRadius: "100px",
                        borderBottomLeftRadius: "100px",
                        borderBottomRightRadius: "100px",
                      }}
                      nodeId="node_ocl75lh7p81q"
                    />
                  </Col>
                  <Col
                    width={{ size: 335, type: "px" }}
                    style={{ marginLeft: "20px" }}
                  >
                    <Support
                      supportChip={{
                        $data: true,
                        id: "260732",
                        type: "struct",
                        title: "赞助列表",
                        default: { type: "struct", id: "260259" },
                        uuid: "eaa12345",
                      }}
                      rightsName="财经"
                      rightsUrl="https://finance.ifeng.com"
                      nodeId="node_ocln1baocw1"
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcj">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_36/324432B18AFCF919ED4C95274F9A5300ED1D76A5_size1_w1000_h50.jpg"
                  text="网友评论"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p81w"
                  hoverStyle=""
                />
                <Comment
                  url="https://finance.ifeng.com/loc/2023fhwqlt"
                  title="凤凰湾区财经论坛2023"
                  nodeId="node_ocl75won371"
                  hoverStyle=""
                />
              </LayoutComponent>
            </Container>
          </Container>
          <Footer year="2022" style={{ marginTop: "60px" }} />
        </Container>
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
